import { bindActionCreators, Dispatch } from 'redux';
import { connect, RootStateOrAny } from 'react-redux';

import { Form, Input, Modal, Radio, Skeleton, Space } from "antd";

import notifier from "utils/notifier";
import { ErrorResponse } from "utils/types";

import { getQuestions, save } from 'store/authorization/survey/actions';

import { ProviderSurveyModalProps } from "./Proptypes";
import { useEffect, useState } from 'react';

const ProviderSurveyModal = ({ getQuestions, save, setVisible, isFetchingQuestions, isSaving, surveyId, ...rest }: ProviderSurveyModalProps) => {

  const [form] = Form.useForm();
  const [questions, setQuestions] = useState<any>({});
  const [inputNames, setInputNames] = useState<any>({});

  useEffect(() => {
    getSurveyQuestions();

  }, []);

  const getSurveyQuestions = () => {
    return getQuestions(surveyId)
      .then((response: any) => {
        setQuestions(response);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err.response?.data.Message || 'Something went wrong, please contact a system administrator.');
      });
  };

  const saveSurvey = (values: any) => {

    const answers: number[] = Object.values(values);

    let answerTexts = [] as string[];
    questions.Questions.map((question: any, qIndex: number) => {
      question.Choices.map((choice: any) => {
        if (choice.Id === answers[qIndex]) {
          choice.FreeText ?
          answerTexts[qIndex] = (inputNames[qIndex + 1] ? inputNames[qIndex + 1] : '') :
          answerTexts[qIndex] = '';
        }
      })
    });

    return save(parseInt(surveyId), questions.ContactPerson, questions.ContactPhone, answers, answerTexts)
      .then((response: boolean) => {
        if (response) {
          notifier.success('Thank you for your help!', 'We appreciate your feedback.');
        }
        setVisible(false);
      })
      .catch((err: ErrorResponse) => {
        notifier.error(err?.response?.data?.Message || 'Something went wrong, please contact a system administrator.');
        setVisible(false);
      });
  };

  const onSubmit = () => {
    form.validateFields().then(values => {
      saveSurvey(values);
    })
  };

  return (
    <Modal
      {...rest}
      title={isSaving ? 'Saving Survey Answers...' : questions.Title}
      onOk={onSubmit}
      okText={'Submit'}
      maskClosable={false}
      width={'600px'}
      closable={false}
      okButtonProps={{ loading: isSaving }}
      cancelButtonProps={{ style: { display: 'none' }}}
    >
      {isFetchingQuestions || isSaving ?
        <Skeleton
          active
          paragraph={{ rows: 4 }}
          avatar
        />
        :
        <Form
          form={form}
          name={'gapMemberSurvey'}
          onFinish={onSubmit}
        >
          {questions.Questions?.map((question: any, index: number) => (
            <Form.Item
              name={question.Id}
              label={index + 1 + '. ' + question.Title}
              labelCol={{ span: 24 }}
              rules={[
                { required: true, message :'Required.' }
              ]}
            >
              <Radio.Group>
                <Space direction='vertical'>
                  {question.Choices.map((choice: any) => (
                    <Radio value={choice.Id}>
                      {choice.Title}
                      {choice.FreeText && <Input value={inputNames[question.Id]} onChange={e => setInputNames((prev: any) => ({...prev, [question.Id]: e.target.value }))} placeholder="Input Name..." />}
                    </Radio>
                  ))}
                </Space>
              </Radio.Group>

            </Form.Item>
          ))}
        </Form>
      }

    </Modal>
  );
};

const mapStateToProps = (state: RootStateOrAny) => ({
  isFetchingQuestions: state.rootReducer.authSurvey.isFetching,
  isSaving: state.rootReducer.authSurvey.isSaving,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    getQuestions,
    save,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ProviderSurveyModal);